import { Network } from 'src/config'

export function isNetworkSupported(chainId: number): boolean {
  return Object.values(Network).includes(chainId)
}
